<template>
  <div
    id="app"
    :class="[{ mobile: isMobile }, { portrait: isMobileView }]"
    :style="{ height: !isMobileView ? `${windowHeight}px` : 'auto' }"
  >
    <Header :id="isMobileView ? 'portrait' : ''" />
    <MainContent :id="isMobileView ? 'portrait' : ''" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import Header from "./components/Header.vue";
import MainContent from "./components/MainContent.vue";

export default {
  name: "App",
  components: {
    Header,
    MainContent,
  },
  computed: {
    ...mapState(["isMobile", "windowHeight"]),
    ...mapGetters(["isMobileView"]),
  },
  mounted() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
    window.onresize = function () {
      document.body.style.height = window.innerHeight;
    };
    window.onresize();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkMobile);
  },
  methods: {
    ...mapActions(["checkMobile"]),
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Open+Sans+Condensed:wght@700&family=Open+Sans:wght@300;400;600&display=swap");

/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.45);
  border-radius: 1px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #fff;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #ddd;
  cursor: pointer;
}
* {
  box-sizing: border-box;
}
html,
body {
  height: 100%;
  margin: 0;
}
body {
  font-family: "Open Sans", Arial;
  font-weight: 300;
  font-size: 20px;
  line-height: 24px;
  #portrait {
    font-size: 14px;
    line-height: 18px;
  }
}
a {
  text-decoration: none;
}
img {
  max-width: 100%;
}
h1 {
  font-size: 64px;
  line-height: 70px;
}
h2 {
  font-size: 36px;
  line-height: 40px;
  font-weight: bold;
}
#app,
body {
  width: 100vw;
}
#app {
  position: fixed;
  top: 0;
  left: 0;
  &.portrait {
    position: relative;
    height: auto !important;
  }
}
.text-red {
  color: #dd2211;
}
.text-blue {
  color: #003274;
}
.ghost-text {
  font-family: "Open Sans Condensed", sans-serif;
  font-size: 180px;
  font-weight: bold;
  text-transform: uppercase;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: rgba(232, 231, 231, 0.35);
  z-index: -1;
}
.btn {
  &.btn-blue {
    color: #003274;
    &:hover {
      &::before {
        background-color: #b5cce8;
      }
    }
    &:before {
      background-color: #fff;
    }
  }
  display: inline-block;
  font-family: "Open Sans", Arial;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 150%;
  text-align: center;
  color: #ffffff;
  cursor: pointer;
  padding: 8px 30px;
  min-width: 180px;
  max-width: 100%;
  position: relative;
  &:before {
    transform: skewX(-10deg);
    content: "";
    background-color: #dd2211;
    position: absolute;
    z-index: -1;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;
    transition: 0.3s;
  }
  &:hover {
    &:before {
      background-color: #c12315;
    }
  }
}
@media only screen and (max-width: 1200px) {
  h1 {
    font-size: 48px;
    line-height: 52px;
  }
  h2 {
    font-size: 30px;
    line-height: 36px;
  }
  .ghost-text {
    font-size: 140px;
  }
}
@media only screen and (max-width: 1024px) {
  body {
    font-size: 18px;
    line-height: 20px;
  }
  h2 {
    font-size: 24px;
    line-height: 28px;
  }
  .ghost-text {
    font-size: 120px;
  }
}
@media only screen and (max-width: 768px) {
  body {
    font-size: 16px;
    line-height: 18px;
  }
  h1 {
    font-size: 36px;
    line-height: 40px;
  }
  h2 {
    font-size: 20px;
    line-height: 24px;
  }
  .ghost-text {
    font-size: 100px;
  }
  ::-webkit-scrollbar {
    display: none;
  }
}

@media only screen and (max-width: 480px) {
  body {
    font-size: 14px;
    line-height: 18px;
  }
  h1 {
    font-size: 30px;
    line-height: 34px;
  }
  h2 {
    font-size: 22px;
    line-height: 26px;
  }
  .ghost-text {
    font-size: 100px;
  }
}

.fadeIn-enter {
  opacity: 0;
  .text-content {
    & > * {
      transform: translateY(50%);
      opacity: 0;
    }
  }
}
.fadeIn-enter-active {
  transition: 2s;
  .text-content {
    & > * {
      transition-duration: 0.8s;
      &:nth-child(1) {
        transition-delay: 0.3s;
      }
      &:nth-child(2) {
        transition-delay: 0.6s;
      }
      &:nth-child(3) {
        transition-delay: 0.9s;
      }
    }
  }
}
.fadeIn-leave-active {
  opacity: 0;
  transition: 0.8s;
}

.slideUp-enter {
  width: 100%;
  height: 100%;
  transform: translateY(100%);
}
.slideUp-enter-active {
  width: 100%;
  height: 100%;
  transition: 0.8s;
}
.slideUp-leave-active {
  width: 100%;
  height: 100%;
  transform: translateY(100%);
  transition: 0.7s;
}

.slideLeft-enter,
.slideLeft-leave-to {
  transform: translateX(100%);
}
.slideLeft-enter-active,
.slideLeft-leave-active {
  transition: 0.8s;
}
</style>
